import React, {useEffect, useState} from "react";

const AutocompleteMulti = React.forwardRef((props, ref) => {
    const [index, setIndex] = useState(-1);
    const [prevIndex, setPrevIndex] = useState(null);
    const [inputVal, setInputVal] = useState('');
    const uniqId = props.id ? props.id : "autocomplete-input-"+Math.round(Math.random() * 1000);

    useEffect(() => {
        setIndex(-1);
        setPrevIndex(null);

        let timeout = setTimeout(() => {
            if (inputVal) props.search(inputVal);  //условие чтобы при клике не выдавать результат всего списка экспортеров как раньше
        }, 300)

        return () => {
            clearTimeout(timeout);
        };
    }, [inputVal]);

    useEffect(() => {
        window.addEventListener('click', closeAutocompleteResult)

        return () => {
            window.removeEventListener('click', closeAutocompleteResult)
        }
    }, []);

    function closeAutocompleteResult(e) {
        if (! e.target.classList.contains('autocomplete-wrap')) {
            setInputVal('');
        }
    }

    useEffect(() => {
        let ul = document.getElementById(uniqId).nextElementSibling;
        let liList = ul.querySelectorAll('li');

        if (liList && liList.length > 0) {
            let curLi = liList[index];

            if (prevIndex && index > prevIndex) {
                curLi.classList.add('autocomplete-hover');
                if (index > 0) liList[prevIndex].classList.remove('autocomplete-hover');

                if ((curLi.offsetTop + curLi.offsetHeight - ul.scrollTop) >= ul.clientHeight) {
                    ul.scrollBy(0, curLi.offsetHeight);
                }
            } else if (prevIndex && index < prevIndex) {
                curLi.classList.add('autocomplete-hover');
                if (index >= 0) liList[prevIndex].classList.remove('autocomplete-hover');

                if ((curLi.offsetTop - ul.scrollTop) < 0) {
                    ul.scrollBy(0, -curLi.offsetHeight);
                }
            } else {
                liList.forEach((li) => {
                    li.classList.remove('autocomplete-hover');
                })
                if (curLi) curLi.classList.add('autocomplete-hover');
            }
        }
    }, [index])

    function searchHandler(e) {
        setInputVal(e.target.value)
    }

    function focusHandler(e) {
        props.search('');
    }

    function focusOutHandler(e) {
        props.clear()
    }

    function hackHandler() {
    }

    function keyDownHandler(e) {
        if (e.key === 'ArrowDown') {
            if (index < (props.data.length - 1)) {
                setPrevIndex(index);
                setIndex(index + 1);
            }
        } else if (e.key === 'ArrowUp') {
            if (index > 0) {
                setPrevIndex(index);
                setIndex(index - 1);
            }
        } else if (e.key === 'Enter') {
            getChoice();
            props.clear();
        }
    }

    function overHandler(e) {
        setPrevIndex(null);
        setIndex(Number(e.target.getAttribute('idx')));
    }

    function formatResult(item, val) {
        return  item.replace(new RegExp(val, 'gi'), '<b>$&</b>');
    }

    function getChoice() {
        // let choiceId = Number(e.target.getAttribute('iid'));
        if (index >= 0) {
            let choiceObj = findObj(index);

            props.choiceHandler(choiceObj, props.name);

            setInputVal('');
        }
    }

    function clickHandler() {
        getChoice()
    }

    function findObj(id) {
        // return props.data.find(o => o.id === id);
        return props.data[index];
    }

    let items = props.data.map((item, index)=>
        <li
            key={item.id}
            className="text-start"
            iid={item.id}
            idx={index}
            onMouseOver={overHandler}
            dangerouslySetInnerHTML={{__html: formatResult(item.name, inputVal)}}
            onClick={clickHandler}
        >
        </li>
    )

    return(
        <div className='autocomplete-wrap'>
            <input
                className="form-control"
                placeholder="Начните ввод"
                id={uniqId}
                value={inputVal}
                onChange={searchHandler}
                onKeyDown={keyDownHandler}
                onFocus={props.focusSearch ? focusHandler : hackHandler}
                onBlur={props.clear ? focusOutHandler : hackHandler}
                ref={ref}
            />

            <ul className='autocomplete shadow-sm bg-body-tertiary rounded'>
                {items}
            </ul>

        </div>
    )
}
)

export default AutocompleteMulti;